export default __webpack_public_path__ + "static/media/zeroRateIndex.2080f058.svg";